import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Forgotpassword from "../views/forgot-password.vue";
import Resetpassword from "../views/reset-password.vue";
import QuoteManagement from "../views/quote-management.vue";
import SingleQuatation from "../views/Single-quotation.vue";
import Notifications from "../views/notifications.vue";
import Setting from "../views/Setting.vue";
import Configuration from "../views/configuration.vue";
import Products from "../views/products.vue";
import ProductsDetails from "../views/product-details.vue";
import store from "../store";
import TestQuoteManagement from "../views/test-quote-management.vue";
import TestSingleQuatation from "../views/Test-Single-Quatation.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
    meta: { requiresAuth: true },
  },
  {
    path: "/setting",
    name: "Setting",
    component: Setting,
    meta: { requiresAuth: true },
  },
  {
    path: "/configuration",
    name: "Configuration",
    component: Configuration,
    meta: { requiresAuth: true },
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
    meta: { requiresAuth: true },
  },
  {
    path: "/product-details/:id",
    name: "Products Details",
    component: ProductsDetails,
    meta: { requiresAuth: true },
  },
  {
    path: "/quote-management",
    name: "Quote Management",
    component: QuoteManagement,
    meta: { requiresAuth: true },
  },
   {
      path: "/test-quote-management",
      name: "Test Quote Management",
      component: TestQuoteManagement,
      meta: { requiresAuth: true },
    },
    
  {
    path: "/single-quotation/:id",
    name: "Single Quotation",
    component: SingleQuatation,
    meta: { requiresAuth: true },
  },
  {
      path: "/test-single-quotation/:id",
      name: "Test Single Quatation",
      component:TestSingleQuatation,
      meta: { requiresAuth: true },
   },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
    meta: { requiresAuth: true },
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/forgot-password",
    name: "Forgotpassword",
    component: Forgotpassword,
  },
  {
    path: "/reset-password/:token",
    name: "Resetpassword",
    component: Resetpassword,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (!store.state.user) {
    await store.dispatch("getUser");
  }
  if (requiresAuth && !store.state.auth?.user) {
    next("/signin");
  } else if (
    (to.path === "/signin" || to.path === "/signup" || !requiresAuth)  &&
    store.state.auth?.user
  ) {
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
